import React, {FC} from 'react';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {MessageBanner} from './messageBanner';
import {MessageBannerAction} from './messageBannerAction';
import {MessageBannerActionGroup} from './messageBannerActionGroup';
import {MessageBannerTitle} from './messageBannerTitle';

/*
 * Props.
 */

interface EditHereMessageBannerProps {
  onEditHereClick: () => void;
  isRounded: boolean;
}

/*
 * Component.
 */

export const EditHereMessageBanner: FC<EditHereMessageBannerProps> = (props) => {
  const theme = useUserTheme();

  return (
    <MessageBanner color={theme.palette.grey.shade40} iconName="draftFilledSmall" isRounded={props.isRounded}>
      <MessageBannerTitle>
        <Trans id="externalediting-title">You are editing this draft in another window</Trans>
      </MessageBannerTitle>
      <MessageBannerActionGroup>
        <MessageBannerAction onClick={props.onEditHereClick}>
          <Trans id="externalediting-edithere">Edit Here</Trans>
        </MessageBannerAction>
      </MessageBannerActionGroup>
    </MessageBanner>
  );
};
